import React from 'react'
import styled from 'styled-components'
import { colors, fontFamilies } from '../../search-common/settings'
import PropTypes from 'prop-types'

const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  visibility: visible;
`

const Checkbox = styled.input`
  width: 0;
  height: 0;
  visibility: hidden;
`

const ToggleBackground = styled.label`
  width: 40px;
  height: 14px;
  border-radius: 9px;
  border: 1px solid ${colors.grayTone3};
  display: inline-block;
  cursor: pointer;
  background-color: ${( props ) => props.checked ? colors.green : colors.grayTone4};
  position: relative;
  transition: all 0.2s ease-in;
  margin-right: 16px;
`

const ToggleBall = styled.div`
  width: 20px;
  height: 20px;
  background-color: white;
  position: absolute;
  border-radius: 100%;
  top: 50%;
  transform: translateY(-50%);
  left: ${( props ) => props.checked ? 'auto' : '-2px'};
  right: ${( props ) => props.checked ? '-2px' : 'auto'};
  border: 1px solid white;
  transition: all 0.5s ease-in;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.5);
`

const Label = styled.label`
  font-family: ${fontFamilies.aeonik};
  font-size: 16px;
  color: ${colors.white};
  cursor: pointer;
  transform: translateY(-1px);
`

/**
 *
 * @param {object} props
 */
const Toggle = ({ id, handleChange, checked, label }) => {
  return (
    <Container>
      <Checkbox type="checkbox" id={id} onChange={handleChange} />
      <ToggleBackground checked={checked} htmlFor={id}>
        <ToggleBall checked={checked} />
      </ToggleBackground>
      <Label htmlFor={id}>{label}</Label>
    </Container>
  )
}

Toggle.propTypes = {
  id: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired
}

export default Toggle
